import { useToastContext } from "components/alert/ToastContext";
import Pageable from "model/page/Pageable";
import ItemPedido from "model/producao/ItemPedido";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable, DataTableStateEvent } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { LoadingContextProvider, useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import GerarOpService from "service/producao/GerarOpService";
import PedidoService from "service/producao/PedidoService";

interface ModalReabrirItemPedidoProps {
    visible: boolean;
    onHide: () => void;
}

const pedidoService = new PedidoService();
const gerarOpService = new GerarOpService();

export default function ModalReabrirItemPedido(props: ModalReabrirItemPedidoProps) {

    const { msgAlerta, msgSucesso, msgErro } = useToastContext();
    const { startLoading, stopLoading } = useLoadingContext();

    const [loading, setLoading] = useState<boolean>(false);
    const [rows, setRows] = useState<ItemPedido[]>([]);
    const [pageable, setPageable] = useState(new Pageable(0, 10, "pedido.numeroPedido,DESC", 0));
    const [totalElements, setTotalElements] = useState<number>(0);

    useEffect(() => {
        load();
    }, [pageable]);

    const load = () => {
        gerarOpService
            .pesquisarItensFechados(pageable)
            .then((list) => {
                setLoading(false);
                setRows(list.content);
                setTotalElements(list.totalElements);
            })
            .catch((error) => {
                console.error(error);
                setLoading(false);
            })
    }

    const onPage = (event: DataTableStateEvent) => {
        setPageable({ ...pageable, page: event.page !== undefined ? event.page : 0, first: event.first });
        setLoading(true);
    };

    const reabrirItem = (item: ItemPedido) => {
        startLoading();
        gerarOpService.reabrirItemPedido(item.id).then(() => {
            msgSucesso("Reabrir item pedido", "Item reaberto com sucesso");
            stopLoading();
            load();
        }).catch((err) => {
            console.log(err)
            if (err && err.data && err.data.message) {
                msgAlerta("Atenção", err.data.message);
            } else {
                msgErro("Erro", "Erro ao reabrir item");
            }
            stopLoading();
        });
    }

    return (
        <>
            <Dialog
                header="Reabrir item de pedido"
                visible={props.visible}
                style={{ width: '70vw', height: '60vh' }}
                onHide={props.onHide}
                onShow={() => {

                }}
                modal
            >
                <DataTable emptyMessage="Nenhum registro encontrado"
                    value={rows} lazy dataKey="id" paginator
                    first={pageable.first} rows={10} totalRecords={totalElements} onPage={onPage}
                    loading={loading} tableStyle={{ minWidth: '75rem' }}
                >
                    <Column field="pedido.numeroPedido" header="Pedido" showFilterOperator={false} showAddButton={false} />

                    <Column field="sequencial" header="Sequência" showFilterOperator={false} showAddButton={false} />

                    <Column field="produto.codigo" header="Cód. Produto" showFilterOperator={false} showAddButton={false} />

                    <Column field="produto.nome" header="Nome Produto" showFilterOperator={false} showAddButton={false} />

                    <Column field="pedido.cliente.nome" header="Cliente" showFilterOperator={false} showAddButton={false} />

                    <Column field="status" header="Status" body={(rowData) => pedidoService.getStatusItem(rowData.status)} />

                    <Column body={(rowData: ItemPedido) => {
                        return (
                            <div>
                                <Button className="btn btn-primary" onClick={() => reabrirItem(rowData as ItemPedido)}>Reabrir item</Button>
                            </div>
                        )
                    }} />
                </DataTable>
            </Dialog>
        </>
    )
}